import './packaging-guidelines.css';
import RestrictionsIcons from "../../../../components/restrictions-icons/restrictions-icons";
import iconEggBox from "../../../../assets/imgs/prepare-shipment/restrictions/icon-egg-box.svg";
import iconNewspaper from "../../../../assets/imgs/prepare-shipment/restrictions/icon-newspaper.svg";
import iconGiftWrapping from "../../../../assets/imgs/prepare-shipment/restrictions/icon-gift-wrapping.svg";
import iconKraftPaper from "../../../../assets/imgs/prepare-shipment/restrictions/icon-kraft-paper.svg";
import iconDrainPump from "../../../../assets/imgs/prepare-shipment/restrictions/icon-drain-pump.svg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";

function PackagingGuidelines() {
  const [tRestrictions] = useTranslation("restrictions");
  const idComponent = "508803f5-4212-489b-8406-cd64b05c9057";
  const [dataInformation, setDataInformation] = useState(() => {
    const newData = {};
    for (let i = 1; i <= 13; i++) {
      newData[`text-${i}`] = "";
    }
    newData["título"] = "";
    return {
      "Disposiciones generales de embalaje": newData,
    };
  });

  const getTexts = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponent}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (currentLng === "es") {
        setDataInformation(
          response.data.textWeb.text_es["Disposiciones generales de embalaje"]
        );
      } else {
        setDataInformation(
          response.data.textWeb.text_us["Disposiciones generales de embalaje"]
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTexts();
  }, []);

  return (
    <>
      <div className='packaging-guidelines-container'>
        <div className="packaging-guidelines">
            <div className='text-info'>
              <p className='header'>
                {dataInformation["título"] ?? ""}
              </p>
              <div className='texts'>
                <p className='title'>
                  <span className="fw-bold font-semibold">
                    {dataInformation["subtitle-bold"] ?? ""}
                  </span>
                  {dataInformation["subtitle"] ?? ""}
                </p>

                <div className='texts-items'>
                  <ul>
                    {dataInformation["textos"] && dataInformation["textos"].split("\n").map((text, index) => (
                      <li key={index}>{text}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className='icons-content'>
              <h5>{dataInformation["titulo-condiciones-embalaje"] ?? ""}</h5>
              <div className='items-content'>

                <div className='item'>
                  <RestrictionsIcons
                    iconSrc={iconEggBox}
                    iconAlt="Egg Box Icon"
                    height="90px"
                    info={dataInformation["icono-1"] ?? ""}
                    fontSize="15px"
                  />
                </div>

                <div className='item'>
                  <RestrictionsIcons
                    iconSrc={iconNewspaper}
                    iconAlt="Newspaper Icon"
                    height="90px"
                    info={dataInformation["icono-2"] ?? ""}
                    fontSize="15px"
                  />
                </div>

                <div className='item'>
                  <RestrictionsIcons
                    iconSrc={iconGiftWrapping}
                    iconAlt="Gift Wrapping Icon"
                    height="90px"
                    info={dataInformation["icono-3"] ?? ""}
                    fontSize="15px"
                  />
                </div>

                <div className='item'>
                  <RestrictionsIcons
                    iconSrc={iconKraftPaper}
                    iconAlt="Kraft Paper Icon"
                    height="90px"
                    info={dataInformation["icono-4"] ?? ""}
                    fontSize="15px"
                  />
                </div>

                <div className='item'>
                  <RestrictionsIcons
                    iconSrc={iconDrainPump}
                    iconAlt="Drain Pump Icon"
                    height="80px"
                    info={dataInformation["icono-5"] ?? ""}
                    fontSize="15px"
                  />
                </div>

              </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default PackagingGuidelines;
